import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to determine if the node details panel is open.
 * TODO: create a state to control the open/close of the detail panel
 */
export const useIsNodeDetailsPanelOpenInGrid = (): boolean => {
  const location = useLocation();

  return useMemo(() => {
    return (
      !!location.pathname.match(/\/d\/(.*)\/details/) ||
      !!location.pathname.match(/\/projects\/(.*)\/proposals\/(.*)\/d\/(.*)\/details/)
    );
  }, [location.pathname]);
};
